import { Header } from './header/Header';
import { InputSection } from './input/InputSection';
import { PreviewSection } from './preview/PreviewSection';
import { SelectSection } from './select/SelectSection';
import { Footer } from './footer/Footer';
import { SelectionContext, useSelectionState } from 'src/contexts/SelectionContext';
import styles from './CampaignAutomationPage.module.css';
import { ClientContextProvider } from 'src/contexts/ClientContextProvider';
import { AssetContextProvider } from 'src/contexts/AssetContextProvider';
import { CampaignCreationSection } from './create/CampaignCreationSection';
import { CampaignMetadataContextProvider } from 'src/contexts/CampaignMetadataContextProvider';

const CampaignAutomationPage = () => {
  const selectionState = useSelectionState();

  return (
    <div className={styles.provider}>
      <ClientContextProvider>
        <SelectionContext.Provider value={selectionState}>
          <main className={styles.page}>
            <Header />
            <SelectSection />
            <AssetContextProvider>
              <CampaignMetadataContextProvider>
                <div className={styles.mainContent}>
                  <div className={styles.leftColumn}>
                    <InputSection />
                    <CampaignCreationSection />
                  </div>
                  <PreviewSection />
                </div>
              </CampaignMetadataContextProvider>
            </AssetContextProvider>
            <Footer />
          </main>
        </SelectionContext.Provider>
      </ClientContextProvider>
    </div>
  );
};

export { CampaignAutomationPage };
